<template>
  <div class="payment-result-container">
    <Nav />

    <div class="main-content mt-16">
      <div
        class="result-card"
        :class="{
          'payment-success': paymentStatus === 'success',
          'payment-failed': paymentStatus === 'failed',
        }"
      >
        <div class="result-header">
          <!-- 成功图标 -->
          <div v-if="paymentStatus === 'success'" class="result-icon success">
            <svg
              width="60"
              height="60"
              viewBox="0 0 60 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="30"
                cy="30"
                r="29"
                stroke="#4caf50"
                stroke-width="2"
                fill="#f1f8e9"
              />
              <path
                d="M20 30L28 38L40 24"
                stroke="#4caf50"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <!-- 失败图标 -->
          <div
            v-else-if="paymentStatus === 'failed'"
            class="result-icon failed"
          >
            <svg
              width="60"
              height="60"
              viewBox="0 0 60 60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="30"
                cy="30"
                r="29"
                stroke="#f44336"
                stroke-width="2"
                fill="#ffebee"
              />
              <line
                x1="20"
                y1="20"
                x2="40"
                y2="40"
                stroke="#f44336"
                stroke-width="3"
                stroke-linecap="round"
              />
              <line
                x1="40"
                y1="20"
                x2="20"
                y2="40"
                stroke="#f44336"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
          </div>

          <!-- 状态文字 -->
          <h1
            v-if="paymentStatus === 'success'"
            class="result-title success-text"
          >
            支付成功
          </h1>
          <h1
            v-else-if="paymentStatus === 'failed'"
            class="result-title failed-text"
          >
            支付失败
          </h1>
        </div>

        <div class="result-content">
          <p v-if="paymentStatus === 'success'" class="result-message">
            您的订单已支付成功！
          </p>
          <p v-else-if="paymentStatus === 'failed'" class="result-message">
            抱歉，支付未完成，请重试或选择其他支付方式。
          </p>
        </div>

        <!-- 订单信息 -->
        <div class="order-info">
          <h2 class="info-title">订单信息</h2>
          <div class="info-item">
            <span class="info-label">订单编号：</span>
            <span class="info-value">{{ orderNumber || "N/A" }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">支付金额：</span>
            <span class="info-value amount">¥{{ amount || "0.00" }}</span>
          </div>
          <div
            class="info-item"
            v-if="paymentStatus === 'failed' && errorMessage"
          >
            <span class="info-label">失败原因：</span>
            <span class="info-value error-text">{{ errorMessage }}</span>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="action-buttons">
          <button class="primary-button" @click="goToHome">返回首页</button>
          <button
            v-if="paymentStatus === 'success'"
            class="secondary-button"
            @click="viewOrder"
          >
            查看订单详情
          </button>
          <button v-else class="secondary-button" @click="retryPayment">
            重新支付
          </button>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Nav from "../components/Nav.vue";
import Footer from "../components/Footer.vue";

export default {
  name: "PaymentResult",
  components: {
    Nav,
    Footer,
  },
  data() {
    return {
      paymentStatus: "pending", // success, failed
      orderNumber: "",
      amount: 0,
      errorMessage: "",
    };
  },
  mounted() {
    // 从路由参数中获取支付状态和订单信息
    this.paymentStatus = this.$route.query.status || "pending";
    this.orderNumber = this.$route.query.orderNumber || "";
    this.amount = parseFloat(this.$route.query.amount) || 0;
    this.errorMessage = this.$route.query.errorMessage || "";

    // 如果没有状态，尝试从本地存储获取
    if (this.paymentStatus === "pending") {
      const savedStatus = localStorage.getItem("paymentStatus");
      const savedOrder = localStorage.getItem("paymentOrderNumber");
      const savedAmount = localStorage.getItem("paymentAmount");

      if (savedStatus) {
        this.paymentStatus = savedStatus;
        this.orderNumber = savedOrder || "";
        this.amount = parseFloat(savedAmount) || 0;

        // 清除本地存储的临时数据
        localStorage.removeItem("paymentStatus");
        localStorage.removeItem("paymentOrderNumber");
        localStorage.removeItem("paymentAmount");
      }
    }
  },
  methods: {
    // 返回首页
    goToHome() {
      this.$router.push("/index");
    },

    // 查看订单详情
    viewOrder() {
      if (this.orderNumber) {
        this.$router.push("/ucenter/orderlist");
      } else {
        this.$router.push("/ucenter/orderlist");
      }
    },

    // 重新支付
    retryPayment() {
      if (this.orderNumber) {
        // 返回到支付页面，带上订单号
        this.$router.push(`/cashier?orderNumber=${this.orderNumber}`);
      } else {
        this.$router.push("/cashier");
      }
    },
  },
};
</script>

<style scoped>
/* 容器样式 */
.payment-result-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
}

/* 主内容区域 */
.main-content {
  flex: 1;
  padding: 40px 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

/* 结果卡片 */
.result-card {
  width: 100%;
  max-width: 600px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 30px;
  text-align: center;
}

/* 结果头部 */
.result-header {
  margin-bottom: 30px;
}

/* 结果图标 */
.result-icon {
  margin: 0 auto 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
}

/* 结果标题 */
.result-title {
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  padding: 0;
}

/* 结果内容 */
.result-content {
  margin-bottom: 20px;
}

/* 成功文本 */
.success-text {
  color: #4caf50;
}

/* 失败文本 */
.failed-text {
  color: #f44336;
}

/* 结果消息 */
.result-message {
  color: #666;
  margin-bottom: 20px;
  font-size: 16px;
}

/* 订单信息区域 */
.order-info {
  border-top: 1px solid #eaeaea;
  padding-top: 20px;
  margin-bottom: 30px;
}

/* 信息标题 */
.info-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 15px;
  color: #333;
}

/* 信息项 */
.info-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 15px;
}

/* 信息标签 */
.info-label {
  color: #666;
}

/* 信息值 */
.info-value {
  color: #333;
  font-weight: 500;
}

/* 金额样式 */
.amount {
  color: #ff6700;
  font-size: 18px;
}

/* 错误文本 */
.error-text {
  color: #f44336;
  flex: 1;
  text-align: right;
}

/* 操作按钮区域 */
.action-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

/* 主要按钮 */
.primary-button {
  padding: 12px 30px;
  background-color: #ff6700;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  min-width: 120px;
}

.primary-button:hover {
  background-color: #ff8533;
}

/* 次要按钮 */
.secondary-button {
  padding: 12px 30px;
  background-color: white;
  color: #333;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  min-width: 120px;
}

.secondary-button:hover {
  border-color: #ff6700;
  color: #ff6700;
}

/* 响应式样式 */
@media (max-width: 768px) {
  .result-card {
    margin: 0 20px;
    padding: 20px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .primary-button,
  .secondary-button {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PaymentResult.vue